import classnames from "classnames";

import { Brand } from "custom-types/Brand";

import FollowingButton from "components/FollowingButton";
import Image from "components/Image";

const MiniBrandHeader = ({
  brand,
  className,
}: {
  brand: Brand;
  className?: string;
}) => {
  return (
    <div
      className={classnames("flex items-center w-full", className)}
      style={{ height: "64px" }}
    >
      {brand.logo && (
        <div style={{ maxWidth: "64px" }}>
          <Image
            src={brand.logo}
            sizes={[64]}
            className="elevation-low rounded-full border border-light-grey"
            alt={`Logo for the brand ${brand.name}`}
          />
        </div>
      )}
      <div className="ml-lg font-bold w-full">
        <div className="text-sm mb-sm">{brand.name}</div>
        <div className="text-xs text-green flex w-full">
          <a
            href={`/brands/${brand.slug}`}
            className="underline block flex-initial"
          >
            Shop products
          </a>
          <FollowingButton
            followeeType="brand"
            followeeId={brand.id}
            className="block flex-initial ml-auto elevation-low rounded-full p-sm -mt-sm"
          />
        </div>
      </div>
    </div>
  );
};

export default MiniBrandHeader;
